import { Typo } from '@geberit/gdds';

// styles
import styles from './sidebar.module.scss';

// components
import { InnerHtml } from 'components/InnerHtml/inner-html';

type SidebarItemFullAdressProps = {
  item: {
    name: string;
    address: string;
    zip: string;
    city: string;
    zip_location: string;
    country: string;
  };
};

function SidebarItemFullAdress({
  item: { name, address, zip, city, zip_location: zipLocation, country },
}: Readonly<SidebarItemFullAdressProps>) {
  return (
    <Typo className={styles.info} variant="p1" fontWeight={400}>
      <InnerHtml className={styles.info__name} as="span" content={name} />
      <InnerHtml className={styles.info__adress} as="span" content={address} />
      {zipLocation ? (
        <InnerHtml className={styles.info__zip} as="span" content={zipLocation} />
      ) : (
        <>
          <InnerHtml className={styles.info__zip} as="span" content={zip} />
          <InnerHtml className={styles.info__zip} as="span" content={city} />
        </>
      )}
      {country && <InnerHtml as="div" content={country} />}
    </Typo>
  );
}

export default SidebarItemFullAdress;
